{
  "familyId": "SPR-LEEN-C-S-K",
  "questions": [
    {
      "id": "SPR-LEEN-C-S-K-001",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een taalleraar vraagt: in welk woord klinkt de C als een S?",
      "options": ["circus", "cola", "computer", "cake"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S of K", "content": "De letter C klinkt als S vóór e en i: circus, cent, citroen. De C klinkt als K vóór a, o en u: cola, computer, cake.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_s",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De taalleraar legt uit: de C klinkt als S vóór de letters e en i. In 'circus' staat de C vóór een i, dus klinkt het als S. Bij cola, computer en cake staat de C vóór a, o of u, dus klinkt het als K.",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "C + i of e → S-klank",
          "C + a, o of u → K-klank",
          "Circus: C + i → S-klank ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! C + i = S-klank: circus.",
          "1": "Je dacht waarschijnlijk dat cola een S-klank heeft. Maar de C in 'cola' staat vóór een o → K-klank. Onthoud: C + a/o/u = K-klank.",
          "2": "Je dacht waarschijnlijk dat computer een S-klank heeft. Maar de C in 'computer' staat vóór een o → K-klank. Onthoud: C + a/o/u = K-klank.",
          "3": "Je dacht waarschijnlijk dat cake een S-klank heeft. Maar de C in 'cake' staat vóór een a → K-klank. Onthoud: C + a/o/u = K-klank."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+o/u een S-klank geeft", "optionIndex": 1 },
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+o een S-klank geeft", "optionIndex": 2 },
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+a een S-klank geeft", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-002",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft een artikel. Welk woord begint met een K-klank?",
      "options": ["centrum", "citroen", "cactus", "circus"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als K-klank", "content": "De C klinkt als K vóór a, o en u: cactus, cola, computer. Vóór e en i klinkt de C als S: centrum, circus.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_k",
      "variantIndex": 2,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De journalist weet: de C klinkt als K vóór de letters a, o en u. In 'cactus' staat de C vóór een a, dus klinkt het als K. Bij centrum, citroen en circus staat de C vóór e of i, dus klinkt het als S.",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "C + a, o of u → K-klank",
          "C + i of e → S-klank",
          "Cactus: C + a → K-klank ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat centrum een K-klank heeft. Maar de C in 'centrum' staat vóór een e → S-klank. Onthoud: C + e/i = S-klank.",
          "1": "Je dacht waarschijnlijk dat citroen een K-klank heeft. Maar de C in 'citroen' staat vóór een i → S-klank. Onthoud: C + e/i = S-klank.",
          "2": "Goed! C + a = K-klank: cactus.",
          "3": "Je dacht waarschijnlijk dat circus een K-klank heeft. Maar de C in 'circus' staat vóór een i → S-klank. Onthoud: C + e/i = S-klank."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.c-klank-s-als-k", "label": "Denkt dat C+e een K-klank geeft", "optionIndex": 0 },
          { "id": "spr.c-klank-s-als-k", "label": "Denkt dat C+i een K-klank geeft", "optionIndex": 1 },
          { "id": "spr.c-klank-s-als-k", "label": "Denkt dat C+i een K-klank geeft", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-003",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een corrector controleert: welk woord heeft een S-klank bij de C?",
      "options": ["cadeau", "cent", "cursus", "camping"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S-klank", "content": "De C klinkt als S vóór e en i. 'Cent' begint met C + e → S-klank. De andere woorden hebben C + a of u → K-klank.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_s_advanced",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De corrector weet: de C klinkt als S vóór e en i. In 'cent' staat de C vóór een e → S-klank. Bij cadeau (C + a), cursus (C + u) en camping (C + a) klinkt de C als K.",
        "solutionSteps": [
          "Bekijk elk woord: welke letter staat ná de C?",
          "Cent: C + e → S-klank ✓",
          "Cadeau: C + a → K-klank",
          "Cursus: C + u → K-klank",
          "Camping: C + a → K-klank"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat cadeau een S-klank heeft. Maar de C in 'cadeau' staat vóór een a → K-klank. Onthoud: C + a = K-klank.",
          "1": "Goed! C + e = S-klank: cent.",
          "2": "Je dacht waarschijnlijk dat cursus een S-klank heeft. Maar de C in 'cursus' staat vóór een u → K-klank. Onthoud: C + u = K-klank.",
          "3": "Je dacht waarschijnlijk dat camping een S-klank heeft. Maar de C in 'camping' staat vóór een a → K-klank. Onthoud: C + a = K-klank."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+a een S-klank geeft", "optionIndex": 0 },
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+u een S-klank geeft", "optionIndex": 2 },
          { "id": "spr.c-klank-k-als-s", "label": "Denkt dat C+a een S-klank geeft", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-004",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een vertaler vertaalt: waarom schrijven we 'concert' met een C en niet met een K of S?",
      "options": [
        "Omdat de C altijd als K klinkt",
        "Omdat de C altijd als S klinkt",
        "Omdat het een Nederlands woord is",
        "Omdat 'concert' een leenwoord is — we houden de originele spelling"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Leenwoorden met C", "content": "Woorden als 'concert', 'circus' en 'cactus' komen uit andere talen (Latijn, Frans). We houden de originele spelling met C, ook al klinkt het als K of S.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_loanword_origin",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De vertaler weet: 'concert' is een leenwoord uit het Frans/Latijn. We houden de originele spelling met C, ook al klinkt het als K of S. Daarom schrijven we 'concert' en niet 'konsert'.",
        "solutionSteps": [
          "'Concert' komt uit het Frans/Latijn",
          "Leenwoorden houden hun originele spelling",
          "Daarom schrijven we C, niet K of S",
          "Andere voorbeelden: circus, cactus, café"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de C altijd als K klinkt. Maar in 'concert' klinkt de eerste C als K (C + o) en de tweede als S (C + e). De C heeft twee klanken. Onthoud: C + a/o/u = K, C + e/i = S.",
          "1": "Je dacht waarschijnlijk dat de C altijd als S klinkt. Maar in 'cactus' klinkt de C als K (C + a). De C heeft twee klanken. Onthoud: C + a/o/u = K, C + e/i = S.",
          "2": "Je dacht waarschijnlijk dat 'concert' een Nederlands woord is. Maar het komt uit het Frans/Latijn. Nederlandse woorden gebruiken K of S, leenwoorden houden de C. Onthoud: C = leenwoord.",
          "3": "Correct! 'Concert' is een leenwoord — we houden de originele spelling met C."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.c-altijd-k", "label": "Denkt dat C altijd als K klinkt", "optionIndex": 0 },
          { "id": "spr.c-altijd-s", "label": "Denkt dat C altijd als S klinkt", "optionIndex": 1 },
          { "id": "spr.c-niet-leenwoord", "label": "Denkt dat concert een Nederlands woord is", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-005",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een redacteur vraagt: in het woord 'december' — klinkt de C als S of als K?",
      "options": ["Als K (want C + e)", "Als S (want C + e)", "Als S (want C + a)", "Als K (want C aan het begin van het woord)"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C in december", "content": "In 'december' staat de C vóór een e. C + e = S-klank. Zeg het hardop: de-SEM-ber. Je hoort duidelijk een S-klank.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_in_context",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De redacteur weet: in 'december' staat de C vóór een e. C + e = S-klank. Zeg het hardop: de-SEM-ber. Je hoort duidelijk een S-klank.",
        "solutionSteps": [
          "Zoek de C in 'december': de-C-ember",
          "Welke letter staat ná de C? → e",
          "C + e = S-klank",
          "December klinkt als de-SEM-ber ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat C + e een K-klank geeft. Maar C + e = S-klank, niet K-klank. Onthoud: C + e/i = S-klank.",
          "1": "Goed! C + e = S-klank: december klinkt als de-SEM-ber.",
          "2": "Je dacht waarschijnlijk dat de C vóór een a staat. Maar in 'december' staat de C vóór een e: de-C-ember. Onthoud: kijk goed naar de letter ná de C.",
          "3": "Je dacht waarschijnlijk dat een C aan het begin van een woord altijd als K klinkt. Maar de positie in het woord maakt niet uit — het is altijd de letter ná de C die de klank bepaalt. In 'december' staat de C vóór een e → S-klank: de-SEM-ber. Vergelijk: cent (begint met C+e → S) vs. cactus (begint met C+a → K)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.c-klank-s-als-k", "label": "Denkt dat C+e een K-klank geeft", "optionIndex": 0 },
          { "id": "spr.c-klank-k-als-s", "label": "Verwart welke letter na de C staat", "optionIndex": 2 },
          { "id": "spr.c-klank-s-als-k", "label": "Denkt dat C aan begin van woord altijd K is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-006",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: klinkt de C als een S of als een K?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["C klinkt als S", "C klinkt als K"],
        "items": [
          { "text": "citroen", "correctCategory": 0 },
          { "text": "cola", "correctCategory": 1 },
          { "text": "centrum", "correctCategory": 0 },
          { "text": "camping", "correctCategory": 1 },
          { "text": "circus", "correctCategory": 0 },
          { "text": "cactus", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S of K", "content": "C + e of i → S-klank (citroen, centrum, circus). C + a, o of u → K-klank (cola, camping, cactus).", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Kijk naar de letter ná de C. C + e of i = S-klank: citroen (C+i), centrum (C+e), circus (C+i). C + a, o of u = K-klank: cola (C+o), camping (C+a), cactus (C+a).",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "C + e/i → S-klank: citroen, centrum, circus",
          "C + a/o/u → K-klank: cola, camping, cactus"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-007",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "categorize",
      "question": "Verdeel deze woorden over de juiste groep: S-klank of K-klank bij de C.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["S-klank", "K-klank"],
        "items": [
          { "text": "cel", "correctCategory": 0 },
          { "text": "cursus", "correctCategory": 1 },
          { "text": "cent", "correctCategory": 0 },
          { "text": "cadeau", "correctCategory": 1 },
          { "text": "cilinder", "correctCategory": 0 },
          { "text": "computer", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S of K", "content": "C + e of i → S-klank (cel, cent, cilinder). C + a, o of u → K-klank (cursus, cadeau, computer).", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_categorize_2",
      "variantIndex": 7,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "C + e/i = S-klank: cel (C+e), cent (C+e), cilinder (C+i). C + a/o/u = K-klank: cursus (C+u), cadeau (C+a), computer (C+o).",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "S-klank: cel, cent, cilinder (C + e of i)",
          "K-klank: cursus, cadeau, computer (C + a, o of u)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-008",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste uitspraak van de C.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "circus", "right": "S-klank (C + i)" },
          { "left": "cake", "right": "K-klank (C + a)" },
          { "left": "december", "right": "S-klank (C + e)" },
          { "left": "cola", "right": "K-klank (C + o)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C-uitspraak koppelen", "content": "Kijk naar de letter ná de C: circus (C+i → S), cake (C+a → K), december (C+e → S), cola (C+o → K).", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Circus: C + i → S-klank. Cake: C + a → K-klank. December: C + e → S-klank. Cola: C + o → K-klank.",
        "solutionSteps": [
          "Circus → S-klank (C + i)",
          "Cake → K-klank (C + a)",
          "December → S-klank (C + e)",
          "Cola → K-klank (C + o)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-009",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke bewering over de C-klank klopt.",
      "data": {
        "statements": [
          { "text": "In 'circus' klinkt de C als een S.", "isTrue": true },
          { "text": "In 'cola' klinkt de C als een S.", "isTrue": false },
          { "text": "In 'cent' klinkt de C als een K.", "isTrue": false },
          { "text": "In 'camping' klinkt de C als een K.", "isTrue": true },
          { "text": "In 'cilinder' klinkt de C als een S.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, false, true, true],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S of K", "content": "C + e of i → S-klank (circus, cent, cilinder). C + a, o of u → K-klank (cola, camping, cactus). Kijk naar de letter ná de C.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_tf",
      "variantIndex": 9,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Pas de regel toe op elk woord: kijk naar de letter ná de C. Circus (C+i → S) ✓, cola (C+o → K, niet S) ✓, cent (C+e → S, niet K) ✓, camping (C+a → K) ✓, cilinder (C+i → S) ✓. Regel: C + e/i = S-klank, C + a/o/u = K-klank.",
        "solutionSteps": [
          "Circus: C + i → S-klank → bewering klopt ✓",
          "Cola: C + o → K-klank → bewering klopt niet ✗",
          "Cent: C + e → S-klank → bewering klopt niet ✗",
          "Camping: C + a → K-klank → bewering klopt ✓",
          "Cilinder: C + i → S-klank → bewering klopt ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-010",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "fill_in",
      "question": "Klinkt de C in 'centrum' als een S of als een K? Typ 'S' of 'K'.",
      "correctAnswer": "S",
      "data": {
        "acceptedAnswers": ["S", "s"],
        "caseSensitive": false,
        "placeholder": "S of K"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C in centrum", "content": "In 'centrum' staat de C vóór een e. C + e = S-klank. Zeg het hardop: SEN-trum.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_fill",
      "variantIndex": 10,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "In 'centrum' staat de C vóór een e. Pas de regel toe: C + e = S-klank. Zeg het hardop: SEN-trum. Je hoort duidelijk een S-klank. Regel: C + e/i = S-klank, C + a/o/u = K-klank.",
        "solutionSteps": [
          "Zoek de C in 'centrum': C-entrum",
          "Welke letter staat ná de C? → e",
          "C + e = S-klank",
          "Centrum klinkt als SEN-trum ✓"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-011",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: klopt de uitleg over de C-klank?",
      "data": {
        "sentences": [
          { "text": "In 'cactus' klinkt de C als een K, want de C staat vóór een a.", "hasError": false },
          { "text": "In 'citroen' klinkt de C als een K, want de C staat vóór een i.", "hasError": true, "correction": "In 'citroen' klinkt de C als een S, want de C staat vóór een i.", "explanation": "C + i = S-klank, niet K-klank. Citroen klinkt als SI-troen." },
          { "text": "In 'computer' klinkt de C als een K, want de C staat vóór een o.", "hasError": false },
          { "text": "Het woord 'concert' is een leenwoord en behoudt de originele spelling met C.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C-klank controleren", "content": "C + e of i → S-klank. C + a, o of u → K-klank. Controleer bij elke zin of de uitleg klopt met de regel.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_error_judge",
      "variantIndex": 11,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De fout zit in zin 2: 'citroen' heeft C + i, dus een S-klank, niet een K-klank. De andere zinnen kloppen: cactus (C+a → K) ✓, computer (C+o → K) ✓, concert is een leenwoord ✓. Regel: C + e/i = S-klank, C + a/o/u = K-klank.",
        "solutionSteps": [
          "Zin 1: cactus, C + a → K-klank → uitleg klopt ✓",
          "Zin 2: citroen, C + i → S-klank, niet K → uitleg FOUT ✗",
          "Zin 3: computer, C + o → K-klank → uitleg klopt ✓",
          "Zin 4: concert is een leenwoord → uitleg klopt ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}